import {Routes} from '@angular/router';
import {AuthGuard} from '../core/security/auth-guard.service';
import {RolesEnum} from '../core/security/roles.enum';
import {ModulesEnum} from '../core/security/modules.enum';
import {MenuGroupEnum} from '../core/security/menu-group.enum';
import {ConferenceComponent} from './conference/conference.component';

export const routes: Routes = [
  {
    path: '',
    component: ConferenceComponent,
    canActivate: [AuthGuard],
    data: {
      menuGroup: MenuGroupEnum.VideoConferenceGroup,
      package: ModulesEnum.VideoConferenceModule,
      permissions: [RolesEnum.VideoConferenceView, RolesEnum.VideoConferenceEdit, RolesEnum.VideoConferenceDelete],
      animation: 'main',
      meta: {
        title: 'Video Conference',
        override: true,
        description: 'Video Conference Information',
        inSideMenu: true,
        iconClass: 'zoom-icon',
        iconClassCode: '',
        // iconClass: 'material-icons',
        // iconClassCode: 'phone_iphone',
      }
    }
  },
];
